import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sai_icon.svg")